import React from "react";

import { CenteredForm } from "../../../../common/components/CenteredForm/CenteredForm";
import { SignInForm } from "../components/SignInForm";

export const SignInView = () => {
  return (
    <CenteredForm>
      <SignInForm />
    </CenteredForm>
  );
};
